var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQrCode(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#E8E8FC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 19H9C7.9 19 7 19.9 7 21V23C7 24.1 7.9 25 9 25H11C12.1 25 13 24.1 13 23V21C13 19.9 12.1 19 11 19ZM16 13C16.55 13 17 12.55 17 12V8C17 7.45 16.55 7 16 7C15.45 7 15 7.45 15 8V12C15 12.55 15.45 13 16 13ZM23 7H21C19.9 7 19 7.9 19 9V11C19 12.1 19.9 13 21 13H23C24.1 13 25 12.1 25 11V9C25 7.9 24.1 7 23 7ZM9 13H11C12.1 13 13 12.1 13 11V9C13 7.9 12.1 7 11 7H9C7.9 7 7 7.9 7 9V11C7 12.1 7.9 13 9 13ZM23 15H21C19.9 15 19 15.9 19 17V19C19 20.1 19.9 21 21 21H23C24.1 21 25 20.1 25 19V17C25 15.9 24.1 15 23 15ZM24 23H17V17C17 15.9 16.1 15 15 15H8C7.45 15 7 15.45 7 16C7 16.55 7.45 17 8 17H15V23C15 24.1 15.9 25 17 25H24C24.55 25 25 24.55 25 24C25 23.45 24.55 23 24 23Z",
    fill: "#3535F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrCode);
export default __webpack_public_path__ + "static/media/qr-code.67230914521a59777d928f8737775efb.svg";
export { ForwardRef as ReactComponent };